import React, {Fragment} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import PollEditor from "../PollEditor";
import FragmentEditor from "../FragmentEditor";
import ModalEditor from "../ModalEditor";
import {loadComponent} from "../../../utils/components";
import Icon from "../../form/Icon";
import QuizAnswerField from "./QuizAnswer/QuizAnswerField";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";


class QuizForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    {this.props.presets?.component_id && this.props.presets?.component && this.props.presets?.field ?
                        <>
                            <div className="col-md-6">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="title"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Név"
                                />
                            </div>
                            <div className="col-md-4">
                                <Select
                                    name="type"
                                    optionname="QuizType"
                                    objectValue={false}
                                    storeType="local"
                                    label="Kvíz típusa"
                                    value={this.props.values.type}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-md-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name={this.props.componentConfig.idfield}
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Kód"
                                />
                            </div>
                        </>
                     :
                        <>
                        <div className="col-md-10">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="title"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Név"
                            />
                        </div>
                        <div className="col-md-2">
                        <ComponentField
                        getFieldProps={this.props.getFieldProps}
                        componentConfig={this.props.componentConfig}
                        name={this.props.componentConfig.idfield}
                        values={this.props.values}
                        setFieldValue={this.props.setFieldValue}
                        label="Kód"
                        />
                        </div>
                        </>
                }
                </div>
                <div className="row form-row">
                    <div className="col-sm-7">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="subtitle"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Alcím"
                        />
                    </div>
                    <div className="col-sm-3">
                        <DateTimeInput
                            name="expiration_time"
                            value={this.props.values.expiration_time}
                            isClearable={true}
                            label="Lejárat ideje"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="expiration_text"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Lejárt űrlap leírása"
                        />
                    </div>
                </div>
                {!!this.props.values[this.props.componentConfig.idfield] && <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Kérdések</label>
                            <PollEditor
                                editorContext="QuizPoll"
                                gridid="QuizPollList"
                                presets={{quiz: this.props.values}}
                                listFilter={{
                                    field: "quiz",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }}
                                list={FragmentEditor}
                                editor={ModalEditor}
                            />
                        </div>
                    </div>
                </div>}
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="completed_text"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Visszaigazoló szöveg"
                        />
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && <QuizAnswerField
                    quiz_id={this.props.values[this.props.componentConfig.idfield]}
                    label="Válaszok"
                />}
                    <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="url"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Url"
                            />
                        </div>
                    </div>
            </form>
        );
    }
}

export default createForm(QuizForm);
